/**
 * custom-product-sya-load-calc.js
 * くい丸システムズ 汎用強度シミュレーター (ver.0.5)
 * 更新: 2026-06
 *
 * 変更点 (ver.0.4→0.5):
 *   - コメント整備・可読性向上
 *   - ロジックは ver.0.4 を維持（正確な肉厚に基づくZ値を適用済み）
 */

/** 各径の断面係数(Z: mm³)・設計基準強度(F: N/mm²)・鋼材規格 */
const KUIMARU_SPECS = {
  '27.2': { Z:  892, F: 235, mat: 'STK400' }, // t1.9mm
  '31.8': { Z: 1093, F: 235, mat: 'STK400' }, // t1.6mm
  '34.0': { Z: 1703, F: 235, mat: 'STK400' }, // t2.3mm
  '38.1': { Z: 2185, F: 235, mat: 'STK400' }, // t2.3mm
  '42.7': { Z: 2896, F: 325, mat: 'STK500' }, // t2.4mm
  '48.6': { Z: 3846, F: 325, mat: 'STK500' }, // t2.4mm
  '60.5': { Z: 5902, F: 235, mat: 'STK400' }  // t2.3mm
};

/**
 * 安全率を計算して返す
 * @param {string} diameter   - くい丸の外径（例: '42.7'）
 * @param {number} span       - 杭間スパン（m）
 * @param {number} hLoad      - 荷重位置の地上高さ（m）
 * @param {string} model      - 荷重モデル: 'uniform'（均等）| 'point'（集中）
 * @param {number} inputLoadKg - 総想定荷重（kgf）
 * @returns {{ material, sf, status, color } | { error, color }}
 */
function calculateKuimaruSafety(diameter, span, hLoad, model, inputLoadKg) {
  const spec = KUIMARU_SPECS[diameter];
  if (!spec) return { error: 'データがありません', color: '#666' };

  const g       = 9.80665;
  const L       = hLoad * 1000;                 // 荷重位置（mm換算）
  const M_yield = spec.F * spec.Z;              // 弾性限度モーメント（N·mm）

  let M_occ = 0;

  if (model === 'uniform') {
    // 均等荷重モデル
    // 1本あたり負担力 = (総荷重 × スパン × g) / 2本
    // 等分布荷重なので有効モーメントアーム = L / 2
    const P_single = (inputLoadKg * span * g) / 2;
    M_occ = (P_single * L) / 2;
  } else {
    // 集中荷重モデル
    // 1本あたり負担力 = 総荷重 × g / 2本
    // 荷重位置の高さ L がそのままモーメントアーム
    const P_single = (inputLoadKg * g) / 2;
    M_occ = P_single * L;
  }

  const safetyFactor = M_yield / M_occ;

  const withinLimit = safetyFactor >= 1.0;
  return {
    material: spec.mat,
    sf:       safetyFactor.toFixed(2),
    status:   withinLimit
      ? '計算上の限度内に収まっています。目的・使用環境に応じた安全率をご検討ください。'
      : '限度を超えた荷重により、くい丸が曲がったまま戻らなくなる恐れがあります。',
    color:    withinLimit ? '#28a745' : '#dc3545'
  };
}